import { map } from '../../../../../common/redux/reducer/commonSlices/mapSlice';

export const useGeofenceMenu = ({
  setIsOpen,
  setIsCircular,
  setFilteredRow,
  setCardOpen,
  dispatch,
  setRow,
  data
}: any) => {
  const handlesilder = () => {
    setIsOpen('slider');
  };

  const handleOpenSlide = () => {
    setIsOpen('');
  };

  // To add new geofence
  const handleAddGeofence = () => {
    setIsOpen('Add Geofence');
    setIsCircular(true);
    setFilteredRow(null);
    setCardOpen(false);
    dispatch(map([]));
    setRow(data);
  };
  return { handlesilder, handleOpenSlide, handleAddGeofence };
};
